export function toggleMemberId(memberIds: Set<string>, userId: string): Set<string> {
  const next: Set<string> = new Set<string>(memberIds);
  if (next.has(userId)) {
    next.delete(userId);
  } else {
    next.add(userId);
  }
  return next;
}
